export default __webpack_public_path__ + "static/media/white_lock.4ecc301b.svg";